import React from 'react'

/**
 * Loader de página para rutas lazy (fallback de Suspense).
 * Renderiza un esqueleto sobre el fondo canvas para evitar el "destello blanco"
 * al cargar el chunk de la página, dando sensación de que el contenido aparece.
 */
export function PageLoader() {
  return (
    <div className="animate-fade-in space-y-6" aria-busy="true" aria-live="polite">
      <span className="sr-only">Cargando…</span>

      {/* Encabezado */}
      <div className="card p-6 flex items-center gap-4">
        <div className="skeleton h-11 w-11 rounded-xl flex-shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="skeleton h-5 w-1/2 max-w-xs" />
          <div className="skeleton h-3 w-3/4 max-w-md" />
        </div>
      </div>

      {/* Fila de KPIs */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="card p-5 space-y-3">
            <div className="skeleton h-3 w-20" />
            <div className="skeleton h-7 w-16" />
            <div className="skeleton h-3 w-24" />
          </div>
        ))}
      </div>

      {/* Bloque de contenido */}
      <div className="card p-6 space-y-3">
        <div className="skeleton h-4 w-40" />
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="skeleton h-4 w-full" />
        ))}
      </div>
    </div>
  )
}

export default PageLoader
